import { render, staticRenderFns } from "./TeachTableSelectorByCategory.vue?vue&type=template&id=1b1597d1"
import script from "./TeachTableSelectorByCategory.vue?vue&type=script&lang=js"
export * from "./TeachTableSelectorByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports